(function () {
  var THREE_CDN = 'https://esm.sh/three@0.164.1';
  var GLTF_CDN = 'https://esm.sh/three@0.164.1/examples/jsm/loaders/GLTFLoader';

  var ROTATION_SPEED = 0.00025;
  var DEFAULT_TILT_DEG = -30;
  var VIEW_SIZE = 10.8;

  function rad(deg) {
    return (deg * Math.PI) / 180;
  }

  function frameModel(model, THREE, viewSize) {
    var bounds = new THREE.Box3().setFromObject(model);
    var center = bounds.getCenter(new THREE.Vector3());
    var size = bounds.getSize(new THREE.Vector3());
    var scale = viewSize / Math.max(size.x, size.y, size.z);
    model.scale.setScalar(scale);
    model.position.set(-center.x * scale, -center.y * scale, -center.z * scale);
  }

  function initSpine(host) {
    if (host._spineInit) return;
    host._spineInit = true;

    var modelUrl = host.dataset.modelUrl;
    if (!modelUrl) return;

    var rotationSpeedMult = parseFloat(host.dataset.rotationSpeed);
    if (isNaN(rotationSpeedMult)) rotationSpeedMult = 1.0;

    var tiltAngle = parseFloat(host.dataset.tiltAngle);
    if (isNaN(tiltAngle)) tiltAngle = DEFAULT_TILT_DEG;

    var useGlbAnimation = host.dataset.useGlbAnimation === 'true';
    var animationName = host.dataset.animationName || '';
    var animationLoop = host.dataset.animationLoop || 'loop';
    var animationSpeed = parseFloat(host.dataset.animationSpeed) || 1.0;
    var modelScale = parseFloat(host.dataset.modelScale);
    if (isNaN(modelScale) || modelScale <= 0) modelScale = 1.0;
    var effectiveViewSize = VIEW_SIZE * modelScale;

    var dynamicImport = new Function('url', 'return import(url)');
    Promise.all([
      dynamicImport(THREE_CDN),
      dynamicImport(GLTF_CDN)
    ]).then(function (modules) {
      var THREE = modules[0];
      var GLTFLoader = modules[1].GLTFLoader;

      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(30, 1, 0.1, 100);
      camera.position.set(0, 0.12, 9.6);

      var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
      renderer.setClearAlpha(0);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.12;
      host.appendChild(renderer.domElement);

      var spineTilt = new THREE.Group();
      if (!useGlbAnimation) {
        spineTilt.rotation.z = rad(tiltAngle);
        spineTilt.rotation.x = rad(5);
      }
      scene.add(spineTilt);

      var spineAxis = new THREE.Group();
      if (!useGlbAnimation) {
        spineAxis.rotation.y = rad(-28);
      }
      spineTilt.add(spineAxis);

      var hemi = new THREE.HemisphereLight(new THREE.Color('#ffffff'), new THREE.Color('#c8d0da'), 1.35);
      var key = new THREE.DirectionalLight(new THREE.Color('#ffffff'), 2.8);
      key.position.set(3.4, 4.5, 5.2);
      var fill = new THREE.DirectionalLight(new THREE.Color('#dbeafe'), 1.6);
      fill.position.set(-4, 1.3, -3);
      scene.add(new THREE.AmbientLight(new THREE.Color('#ffffff'), 0.55), hemi, key, fill);

      var pointer = new THREE.Vector2(0, 0);
      var targetPtr = new THREE.Vector2(0, 0);
      var hover = 0;
      var targetHover = 0;
      var width = 0;
      var height = 0;
      var loadedModel = null;
      var hoveredPart = null;
      var frameId = 0;
      var raycaster = new THREE.Raycaster();
      var vertebraParts = [];
      var meshToPart = new Map();
      var diskMeshes = new Set();
      var accumulatedTime = 0;
      var lastTimestamp = null;
      var mixer = null;

      var mat = new THREE.MeshPhysicalMaterial({
        color: new THREE.Color('#f7fbff'),
        roughness: 0.34,
        metalness: 0,
        clearcoat: 0.28,
        clearcoatRoughness: 0.3,
      });

      var loader = new GLTFLoader();
      loader.load(modelUrl, function (gltf) {
        loadedModel = gltf.scene;
        frameModel(loadedModel, THREE, effectiveViewSize);
        if (!useGlbAnimation) {
          loadedModel.traverse(function (child) {
            if (child instanceof THREE.Mesh) child.material = mat;
          });
        }

        spineAxis.add(loadedModel);

        if (useGlbAnimation) {
          if (gltf.animations && gltf.animations.length > 0) {
            mixer = new THREE.AnimationMixer(loadedModel);
            var clip = gltf.animations[0];
            if (animationName) {
              var trimmedName = animationName.trim().toLowerCase();
              var availableNames = gltf.animations.map(function (a) { return a.name; });
              console.log('[white-hero] Available animation clips:', availableNames);
              for (var i = 0; i < gltf.animations.length; i++) {
                if (gltf.animations[i].name.toLowerCase() === trimmedName) {
                  clip = gltf.animations[i];
                  break;
                }
              }
              if (clip === gltf.animations[0] && gltf.animations[0].name.toLowerCase() !== trimmedName) {
                console.warn('[white-hero] Animation "' + animationName + '" not found. Playing first clip: "' + gltf.animations[0].name + '". Available:', availableNames);
              }
            } else {
              console.log('[white-hero] No animation name set. Playing first clip: "' + gltf.animations[0].name + '". Available:', gltf.animations.map(function (a) { return a.name; }));
            }
            var loopMode = animationLoop === 'once' ? THREE.LoopOnce
              : animationLoop === 'pingpong' ? THREE.LoopPingPong
              : THREE.LoopRepeat;
            var action = mixer.clipAction(clip);
            action.setLoop(loopMode);
            if (loopMode === THREE.LoopOnce) action.clampWhenFinished = true;
            action.timeScale = animationSpeed;
            action.play();
          }
        } else {
          var group = loadedModel.getObjectByName('Group01') || loadedModel;

          group.children
            .filter(function (c) { return c.name.toLowerCase().includes('disks'); })
            .forEach(function (dg) {
              dg.traverse(function (c) {
                if (c instanceof THREE.Mesh) diskMeshes.add(c);
              });
            });

          group.children
            .filter(function (c) { return c.children.length > 0 && !c.name.toLowerCase().includes('disks'); })
            .forEach(function (root) {
              root.traverse(function (c) {
                if (c instanceof THREE.Mesh) {
                  vertebraParts.push({ base: c.position.clone(), mesh: c });
                  meshToPart.set(c, c);
                }
              });
            });
        }
      });

      function resize() {
        var w = host.clientWidth;
        var h = host.clientHeight;
        if (w === width && h === height) return;
        width = w;
        height = h;
        renderer.setSize(w, h);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
      }

      function onMove(e) {
        var r = host.getBoundingClientRect();
        targetPtr.x = ((e.clientX - r.left) / r.width) * 2 - 1;
        targetPtr.y = -(((e.clientY - r.top) / r.height) * 2 - 1);
        targetHover = 1;
      }

      function onLeave() { targetHover = 0; }

      if (!useGlbAnimation) {
        host.addEventListener('pointermove', onMove);
        host.addEventListener('pointerleave', onLeave);
      }

      function animate(ts) {
        var delta = lastTimestamp !== null ? ts - lastTimestamp : 0;
        accumulatedTime += delta;
        lastTimestamp = ts;

        resize();

        if (useGlbAnimation) {
          if (mixer) mixer.update(delta / 1000);
        } else {
          pointer.lerp(targetPtr, 0.08);
          hover += (targetHover - hover) * 0.08;
          spineAxis.rotation.y = rad(-28) + accumulatedTime * ROTATION_SPEED * rotationSpeedMult;

          if (loadedModel && targetHover > 0) {
            spineTilt.updateMatrixWorld(true);
            raycaster.setFromCamera(pointer, camera);
            var hits = raycaster.intersectObject(loadedModel, true);
            var hit = hits[0] && hits[0].object;
            hoveredPart = hit && !diskMeshes.has(hit) ? (meshToPart.get(hit) || null) : null;
          } else {
            hoveredPart = null;
          }

          vertebraParts.forEach(function (vp) {
            var target = vp.mesh === hoveredPart ? 1.15 : 0;
            var cur = vp.mesh.position.x - vp.base.x;
            vp.mesh.position.set(
              vp.base.x + cur + (target - cur) * 0.12,
              vp.base.y,
              vp.base.z
            );
          });
        }

        renderer.render(scene, camera);
        frameId = requestAnimationFrame(animate);
      }

      frameId = requestAnimationFrame(animate);

      host._spinePause = function () {
        if (frameId) {
          cancelAnimationFrame(frameId);
          frameId = 0;
          lastTimestamp = null;
        }
      };

      host._spineResume = function () {
        if (!frameId) frameId = requestAnimationFrame(animate);
      };

      host._spineDestroy = function () {
        cancelAnimationFrame(frameId);
        if (!useGlbAnimation) {
          host.removeEventListener('pointermove', onMove);
          host.removeEventListener('pointerleave', onLeave);
        }
        if (mixer) mixer.stopAllAction();
        renderer.dispose();
        mat.dispose();
      };
    }).catch(function (err) {
      console.warn('[white-hero] Failed to load Three.js:', err);
    });
  }

  function initSlider(section) {
    var slides = Array.from(section.querySelectorAll('.wh-slide'));
    if (slides.length === 0) return;

    var dots = Array.from(section.querySelectorAll('.wh-slider-dot'));
    var current = 0;
    var autoPlay = section.dataset.autoSlide === 'true';
    var duration = (parseInt(section.dataset.slideDuration, 10) || 5) * 1000;
    var timer = null;

    function activateSpines(slide) {
      slide.querySelectorAll('.wh-spine-host').forEach(function (host) {
        if (!host._spineInit) {
          initSpine(host);
        } else if (host._spineResume) {
          host._spineResume();
        }
      });
    }

    function deactivateSpines(slide) {
      slide.querySelectorAll('.wh-spine-host').forEach(function (host) {
        if (host._spinePause) host._spinePause();
      });
    }

    activateSpines(slides[0]);

    if (slides.length === 1) return;

    function goTo(index) {
      if (index === current) return;
      deactivateSpines(slides[current]);
      slides[current].classList.remove('wh-slide--active');
      if (dots[current]) dots[current].classList.remove('wh-slider-dot--active');
      current = index;
      slides[current].classList.add('wh-slide--active');
      if (dots[current]) dots[current].classList.add('wh-slider-dot--active');
      activateSpines(slides[current]);
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function startTimer() {
      if (!autoPlay) return;
      stopTimer();
      timer = setInterval(function () { goTo((current + 1) % slides.length); }, duration);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startTimer(); });
    });

    if (autoPlay) {
      startTimer();
      section.addEventListener('mouseenter', stopTimer);
      section.addEventListener('mouseleave', startTimer);
    }

    var SWIPE_THRESHOLD = 40;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchTracking = false;

    section.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchTracking = true;
    }, { passive: true });

    section.addEventListener('touchend', function (e) {
      if (!touchTracking) return;
      touchTracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) {
        goTo((current + 1) % slides.length);
      } else {
        goTo((current - 1 + slides.length) % slides.length);
      }
      startTimer();
    }, { passive: true });

    section._sliderGoTo = function (index) { goTo(index); startTimer(); };
  }

  function init(root) {
    root.querySelectorAll('.wh-section').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.wh-spine-host').forEach(function (host) {
      if (host._spineDestroy) host._spineDestroy();
    });
  });

  // When a block is selected in the editor, jump to its slide
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target;
    if (!slide || !slide.classList.contains('wh-slide')) return;
    var section = slide.closest('.wh-section');
    if (!section || !section._sliderGoTo) return;
    var index = parseInt(slide.dataset.index, 10);
    if (!isNaN(index)) section._sliderGoTo(index);
  });
})();
